export const PERMS = {
    READ: 'report_vehicle_costs.read',
    EXPORT: 'report_vehicle_costs.export',
}
